import { render, staticRenderFns } from "./NexusSyncSetting.vue?vue&type=template&id=566f84e9&"
import script from "./NexusSyncSetting.vue?vue&type=script&lang=js&"
export * from "./NexusSyncSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports